import { render as renderIndex } from './screens/index/index-screen.js';
import { render as renderGame } from './screens/game/game-screen.js';
import {
  canUsePanel, isDetailPanelOpen, openDetailPanel, setDetailPanelClose, setDetailPanelPath,
} from './components/detail-panel.js';
import { setPageTitle } from '../../../src/shared/page-title.js';
import { trackFunnelStep } from '../../../src/client/funnel.js';

function currentPathMatches(params) {
  const match = window.location.pathname.match(/^\/library\/g\/([^/]+)\/([^/]+)\/?$/);
  if (!match) return false;
  try {
    return decodeURIComponent(match[1]) === params.system
      && decodeURIComponent(match[2]) === params.slug;
  } catch {
    return false;
  }
}

/**
 * Route handler shared by direct game-detail URLs and catalog side-panel
 * navigation. A successful result is the single contract the router uses to
 * emit the page view; the funnel branch is emitted at the same boundary.
 */
export async function renderGameDetailRoute(params, ctx) {
  const expectedPath = `/library/g/${encodeURIComponent(params.system)}/${encodeURIComponent(params.slug)}`;
  const routeIsCurrent = () => ctx.isCurrent() && currentPathMatches(params);

  let rendered;
  if (canUsePanel()) {
    // A catalog-origin panel restores the already-successful cached index
    // synchronously. A direct detail link may start its backdrop load in
    // parallel, but the detail outcome remains the route's success boundary.
    void Promise.resolve(renderIndex({}, ctx)).catch(() => {});
    const panelRoot = openDetailPanel(renderGame);
    setDetailPanelPath(expectedPath);
    setDetailPanelClose(() => {
      history.replaceState(null, '', '/library');
      setPageTitle('Game Library');
    });
    rendered = await renderGame(params, {
      root: panelRoot,
      isCurrent: () => routeIsCurrent() && isDetailPanelOpen(),
    });
    if (!isDetailPanelOpen()) return false;
  } else {
    rendered = await renderGame(params, { ...ctx, isCurrent: routeIsCurrent });
  }

  if (!rendered || !routeIsCurrent()) return false;
  trackFunnelStep('game_detail', { surface: 'library', system_id: params.system });
  return true;
}
